import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { FormField } from '../../../interfaces/form.interface';

@Component({
    selector: 'app-reactive-switch-field',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './switch-field.component.html',
})
export class ReactiveSwitchFieldComponent<T> {
    @Input() field!: FormField<T>;

    @Input() model!: FormGroup;

    @Input() isEditable = false;

    @Input() describedById = '';

    @Input() isInvalid = false;
}
